import { render, staticRenderFns } from "./BatchReviewDetails.vue?vue&type=template&id=b341a8e0"
import script from "./BatchReviewDetails.vue?vue&type=script&lang=js"
export * from "./BatchReviewDetails.vue?vue&type=script&lang=js"
import style0 from "./BatchReviewDetails.vue?vue&type=style&index=0&id=b341a8e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports